import { render, staticRenderFns } from "./qrCodeDots.vue?vue&type=template&id=fb1c6a9a&scoped=true"
import script from "./qrCodeDots.vue?vue&type=script&lang=js"
export * from "./qrCodeDots.vue?vue&type=script&lang=js"
import style0 from "./qrCodeDots.vue?vue&type=style&index=0&id=fb1c6a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1c6a9a",
  null
  
)

export default component.exports